<template>
  <v-sheet class="chart">
    <div
      class="line"
      v-for="(line, index) in lines"
      :key="line.label"
    >
      <div
        class="label"
        :class="{
          small: (index < lines.length - 1),
          smaller: (index === lines.length - 1)
        }"
      >
        {{ labels[index] }}:
      </div>
      <div class="bar">
        <strong class="bar-title small">{{ line.title }}</strong>
        <v-progress-linear
          height="10"
          v-bind="line.props"
          :color="color"
        />
      </div>
    </div>
  </v-sheet>
</template>

<script>
import ChartReadyMixin from '@/mixins/ChartReadyMixin'
import { format } from '@/utils/format'

export default {
  name: 'ChartBars',

  mixins: [ChartReadyMixin],

  props: {
    type: {
      validator (value) {
        return ['time', 'amount'].includes(value)
      },
      default: 'time'
    },
    entry: Object,
    labels: {
      type: Array,
      default () {
        return []
      }
    },
    color: {
      type: String,
      default: 'primary'
    }
  },

  computed: {
    empty () {
      return !this.entry.current
    },
    lines () {
      const { type, entry, value, diff, ready } = this
      const title = type === 'amount' || type === 'time'
        ? `${entry.label}: ${format(type)(entry.current)} / ${format(type)(entry.adjusted)} (${value}%)`
        : `${entry.label}: ${value}%`
      return [
        {
          title,
          props: {
            value: (ready ? value : 0)
          }
        },
        {
          title: format(type)(entry.accepted),
          props: {
            bufferValue: (ready ? diff : 0)
          }
        },
        {
          title: format(type)(entry.adjusted - entry.accepted),
          props: {
            value: (ready ? 100 - diff : 0),
            backgroundColor: 'transparent',
            reverse: true
          }
        }
      ]
    },
    value () {
      return (this.entry.adjusted ? (this.entry.current / this.entry.adjusted * 100) : 0).toFixed(2)
    },
    diff () {
      return (this.entry.accepted / this.entry.adjusted * 100).toFixed(2)
    }
  }
}
</script>

<style scoped>
.chart {
  margin: 0.5em;
}

.line {
  display: flex;
  margin-block-start: .25em;
}

.label {
  text-align: end;
  flex: 1;
  align-self: end;
}

.bar {
  flex: 4;
  margin-inline-start: .75em;
}

.bar-title {
  display: block;
  text-align: end;
}

.small {
  font-size: .8em;
}

.smaller {
  font-size: .66em;
}
</style>
